(function () {
  if (window.__qcProductCardSecondaryTouch) return;
  window.__qcProductCardSecondaryTouch = true;

  const touchMedia = window.matchMedia('(hover: none) and (pointer: coarse)');
  if (!touchMedia.matches) return;

  const PREVIEW_DELAY_MS = 150;
  const NAV_SUPPRESS_MIN_MS = PREVIEW_DELAY_MS + 150;
  const MOVE_THRESHOLD_PX = 12;
  const PREVIEW_CLASS = 'product-card-wrapper--secondary-preview';

  let activeWrapper = null;
  let previewTimer = null;
  let startX = 0;
  let startY = 0;
  let touchStartTime = 0;
  let previewActive = false;
  let suppressClick = false;

  function hasSecondaryImage(wrapper) {
    return Boolean(wrapper.querySelector('.media.media--hover-effect > img + img'));
  }

  function clearPreview() {
    if (previewTimer) {
      clearTimeout(previewTimer);
      previewTimer = null;
    }
    if (activeWrapper) {
      activeWrapper.classList.remove(PREVIEW_CLASS);
      activeWrapper = null;
    }
    previewActive = false;
  }

  document.addEventListener(
    'touchstart',
    (event) => {
      if (event.touches.length !== 1) return;

      const wrapper = event.target.closest('.product-card-wrapper');
      if (!wrapper || !hasSecondaryImage(wrapper)) return;
      if (event.target.closest('button, input, select, textarea, a[href]:not(.card__heading a)')) return;

      activeWrapper = wrapper;
      previewActive = false;
      touchStartTime = Date.now();
      startX = event.touches[0].clientX;
      startY = event.touches[0].clientY;

      previewTimer = setTimeout(() => {
        if (activeWrapper !== wrapper) return;
        wrapper.classList.add(PREVIEW_CLASS);
        previewActive = true;
      }, PREVIEW_DELAY_MS);
    },
    { passive: true }
  );

  document.addEventListener(
    'touchmove',
    (event) => {
      if (!activeWrapper || event.touches.length !== 1) return;

      const dx = event.touches[0].clientX - startX;
      const dy = event.touches[0].clientY - startY;
      if (Math.hypot(dx, dy) > MOVE_THRESHOLD_PX) {
        clearPreview();
      }
    },
    { passive: true }
  );

  function onTouchEnd() {
    if (!activeWrapper) return;

    const touchDurationMs = Date.now() - touchStartTime;
    const shouldSuppressClick = previewActive && touchDurationMs >= NAV_SUPPRESS_MIN_MS;
    clearPreview();

    if (shouldSuppressClick) {
      suppressClick = true;
      window.setTimeout(() => {
        suppressClick = false;
      }, 400);
    }
  }

  document.addEventListener('touchend', onTouchEnd, { passive: true });
  document.addEventListener('touchcancel', onTouchEnd, { passive: true });

  document.addEventListener(
    'click',
    (event) => {
      if (!suppressClick) return;

      const link = event.target.closest('.product-card-wrapper .card__heading a[href]');
      if (!link) return;

      event.preventDefault();
      suppressClick = false;
    },
    true
  );

  document.addEventListener(
    'contextmenu',
    (event) => {
      const wrapper = event.target.closest('.product-card-wrapper');
      if (!wrapper || !hasSecondaryImage(wrapper)) return;
      if (event.target.closest('button, input, select, textarea')) return;

      event.preventDefault();
    },
    true
  );
})();
